import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { useWeather } from "@/lib/weather";
import { articlePath, formatRelativeDate } from "@/lib/readoo";

// Box "Notizie da [città]": compare solo se il lettore ha scelto la sua città e ci sono notizie delle ultime 48 ore.
export function LocalNewsBox({ excludeId = "", className = "mt-10", testid = "local-news-box" }) {
  const { city } = useWeather();
  const [items, setItems] = useState([]);
  const chosen = city?.manual;
  const { name, lat, lon } = city || {};

  useEffect(() => {
    if (!chosen || !name) { setItems([]); return; }
    let alive = true;
    const q = new URLSearchParams({ name, lat, lon, exclude: excludeId, limit: 4 });
    apiFetch(`/local-news?${q}`, { auth: false }).then((r) => alive && setItems(r.articles || [])).catch(() => {});
    return () => { alive = false; };
  }, [chosen, name, lat, lon, excludeId]);

  if (!items.length) return null;
  return (
    <section data-testid={testid} className={`${className} rounded-2xl border border-hair bg-surfaceSecondary p-5 sm:p-6`}>
      <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-onSurface mb-4">
        <MapPin size={18} className="text-brand" /> Notizie da {name}
      </h2>
      <ul className="divide-y divide-hair">
        {items.map((a, i) => (
          <li key={a.article_id}>
            <Link to={articlePath(a)} data-testid={`local-news-item-${i}`} className="group flex gap-3 py-3">
              {a.image && <img src={a.image} alt="" loading="lazy" className="w-20 h-14 rounded-lg object-cover shrink-0" />}
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-onSurface group-hover:text-brand transition-colors line-clamp-2">{a.title}</span>
                <span className="font-mono text-[11px] text-subtle">{formatRelativeDate(a.published_at)}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
